import { ActionCreators } from '../../login/auth';
import { errorAction } from '../notifications';
import { checkTokenExpiration } from './checkTokenExpiration';
import { ActionTypes } from './sessionExpiration';
import ManagerState from '../../app/store/state';

const SessionExpirationMessage = 'Your session has expired.';
let managerScheduledTiemout;
const ExpirationCheckTimeInterval = 60 * 1000;

function getTokenFromState(state: ManagerState) {
    return state.auth.apiToken;
}
function onTokenExpiration(dispatch) {
    dispatch(ActionCreators.logout());
    dispatch(errorAction(SessionExpirationMessage));
}
function showSessionProlongAlert() {
    return {
        type: ActionTypes.showSessionProlongAlert,
    };
}
function autoRefreshToken() {
    return ActionCreators.refreshToken();
}
function scheduleManagerTokenExpirationChecks() {
    return (dispatch) => {
        if (managerScheduledTiemout) {
            clearInterval(managerScheduledTiemout);
        }

        dispatch(checkTokenExpiration(getTokenFromState, onTokenExpiration, showSessionProlongAlert, autoRefreshToken));

        managerScheduledTiemout = setInterval(() => {
            dispatch(
                checkTokenExpiration(getTokenFromState, onTokenExpiration, showSessionProlongAlert, autoRefreshToken)
            );
        }, ExpirationCheckTimeInterval);
    };
}
export default scheduleManagerTokenExpirationChecks;
